const baseUrl="https://glizmednode.destinoinfotech.com/"
export const api={ 
    baseUrl:"https://glizmednode.destinoinfotech.com/"
}